// 法语----address
module.exports = {
  validate: {
    noEmail: "L'e-mail ne peut pas être vide, veuillez le saisir à nouveau",
    noPhone:
      "Le numéro de téléphone ne peut pas être vide, veuillez le saisir à nouveau",
    errorReg:
      "La longueur d'entrée est de 1 à 50 chiffres, vous pouvez saisir des lettres majuscules et minuscules, des chiffres, des symboles - . _ @",
    noPassword:
      "Le mot de passe ne peut pas être vide, veuillez le saisir à nouveau",
    pwdReg:
      "La longueur d'entrée du mot de passe est de 8 à 32 chiffres uniquement et doit contenir des chiffres et des lettres",
    pwdCheck:
      " Les deux mots de passe saisis sont incohérents, veuillez les saisir à nouveau  ",
    pwdLengthReg:
      "La longueur du mot de passe varie de 8 à 32, veuillez confirmer la saisie",
    noCode: "veuillez entrer le code de vérification",
    codeReg: "Veuillez entrer un code de vérification à 6 chiffres",
    nullText: "L'entrée ne peut pas être vide, veuillez la saisir à nouveau",
    phoneCheck:
      "Le numéro de téléphone saisi deux fois est incohérent, veuillez le saisir à nouveau",
    emailNumReg:
      "La longueur d'entrée de l'e-mail est de 6 à 50 caractères, veuillez saisir à nouveau",
    emailReg: " Adresse e - mail incorrecte,veuillez la saisir à nouveau  ",
    emailCheck:
      "Le compte de messagerie saisi deux fois est incohérent, veuillez le saisir à nouveau",
    noUsername:
      "Le mot de passe ne peut pas contenir le numéro de compte, veuillez le saisir à nouveau",
    accountReg:
      "La saisie du nom de compte est incorrecte, veuillez la saisir à nouveau",
  },
  area: {
    areaTitle: "Gestion de territoire",
    add: "Ajouter une zone",
    area: "zone",
    addNextArea: "Créer une nouvelle zone subordonnée",
    areaNameTip: "Veuillez entrer un nom de région",
    areaNameHold:
      "La longueur d'entrée est de 1 à 20 chiffres, aucun symbole spécial ne peut être saisi",
    areaNumHold:
      "La longueur d'entrée est de 1 à 4 chiffres, seuls des nombres peuvent être saisis et la plage de nombres est de 0 à 9999",
    areaNumTip: "Veuillez entrer le numéro de zone",
    areaName: "Nom de zone",
    checkAreaName:
      "Le nom de la zone ne peut pas être vide, veuillez le saisir à nouveau",
    areaNameTip1: "Le nom de la zone ne peut pas être vide",
    areaNameTip2: "Entrée incorrecte du nom de zone, veuillez ré-entrer",
    areaNum: "Numéro de zone",
    checkAreaNum:
      "L'identifiant de zone ne peut pas être vide, veuillez le saisir à nouveau",
    lastLevel: "Appartient à la zone supérieure",
    checkLastLevel:
      "La zone de niveau supérieur à laquelle il appartient ne peut pas être vide, veuillez sélectionner à nouveau",
    lastLevelTip:
      "Veuillez sélectionner l'espace parent auquel vous appartenez",
    delInfo:
      "L'exécution de cette tâche de suppression supprimera les données de cette zone et ne pourra pas être récupérée",
    oneStep: "premier niveau",
    twoStep: "secondaire",
    threeStep: "Niveau 3",
    fourStep: "Niveau 4",
    fiveStep: "Niveau 5",
    delAreaTip: "Il y a une zone subordonnée, qui ne peut pas être supprimée",
    personArea: "La personne n'est pas liée à la zone",
    areaType: "Ajouter une méthode",
    addArea1: "Ajouter séparément",
    addArea2: "addition continue",
    addArea3: "Ajout de matrice",
    areaNameTop: "Préfixe du nom de zone",
    areaNameLast: "Suffixe du nom de zone",
    areaJoinHold: "Veuillez saisir le préfixe du nom de domaine",
    areaJoinHold1: "Veuillez entrer le suffixe du nom de la zone",
    startNum: "Numéro de départ",
    checkStartNum:
      "Le numéro initial saisi est erroné, veuillez le saisir à nouveau",
    checkStartNum1:
      "L'entrée du numéro de départ ne peut pas être vide, veuillez le saisir à nouveau",
    checkEndNum:
      "L'entrée du numéro de fin est erronée, veuillez le saisir à nouveau",
    checkEndNum1:
      "Le numéro de fin ne peut pas être vide, veuillez le saisir à nouveau",
    endNum: "Numéro de fin",
    topStart: "Numéro de début d'en-tête",
    checkTopStart:
      "La saisie du premier numéro de départ est incorrecte, veuillez le saisir à nouveau",
    checkTopStart1:
      "L'entrée du premier numéro de départ ne peut pas être vide, veuillez ré-entrer",
    topEnd: "Numéro de fin d'en-tête",
    checkTopEnd:
      "Entrez le numéro de fin de l'en-tête est incorrect, veuillez le saisir à nouveau",
    checkTopEnd1:
      "L'entrée du premier numéro de fin ne peut pas être vide, veuillez ressaisir",
    lastStart: "Numéro de début de queue",
    checkLastStart:
      "La saisie du numéro de départ de la queue est erronée, veuillez le saisir à nouveau",
    checkLastStart1:
      "Entrez le numéro de départ de la queue ne peut pas être vide, veuillez le saisir à nouveau",
    lastEnd: "Numéro de fin de piste",
    checkLastEnd:
      "Entrez le numéro de fin de la queue est erroné, veuillez le saisir à nouveau",
    checkLastEnd1:
      "L'entrée du numéro de fin de queue ne peut pas être vide, veuillez entrer à nouveau",
    topTip:
      "La longueur d'entrée est de 1 à 2 chiffres, seuls des nombres peuvent être saisis et la plage de nombres est de 1 à 99",
    lastTip:
      "La longueur d'entrée est de 1 à 2 chiffres, seuls des nombres peuvent être saisis et la plage de nombres est de 1 à 99",
    areaNameTest: "Exemple de nom de zone",
  },
  addressBook: {
    config: "Configuration du projet",
    errorTip: "Erreur de format du carnet d'adresses",
    upgrade: "Gestion de la mise à jour du carnet d'adresses",
    deviceIdTip: "Veuillez entrer l'ID de l'appareil",
    deviceId: "Reference de l'appareil",
    syncAll: "Tout synchroniser",
    sync: "Synchroniser",
    sysVersion: "Version actuelle du carnet d'adresses système",
    deviceVersion: "Version actuelle du carnet d'adresses de l'appareil",
    syncTip: "La commande synchrone a été émise avec succès",
  },
  newarea: {
    add: "Ajouter une zone",
    edit: "Zone d'édition",
    smallTip:
      "Actuellement le plus petit niveau de zone, aucune autre sous-zone ne peut être ajoutée",
    batch: "Zone d'ajout par lots",
    batch1: "addition continue",
    batch2: "Ajout de matrice",
  },
  deviceSip: {
    saveTip:
      "Veuillez exporter le carnet d'adresses à temps, sinon toutes les données seront effacées après avoir quitté la page.",
    devMsg: "Informations sur l'appareil",
    list: "Liste des périphériques",
    add: "Ajouter un appareil",
    edit: "Modifier l'appareil",
    batch: "Ajouter des appareils par lots",
    areaChosen: "Sélection au niveau de la zone",
    areaNum: "Nombre d'appareils nouvellement ajoutés dans chaque zone",
    bacthTip:
      "Lorsque le niveau de la zone est sélectionné en tant que bâtiment et que le nombre de nouveaux appareils dans chaque zone est de 4, cela signifie que 4 appareils sont ajoutés dans chaque zone créée",
    note: "illustrer",
    baseConfig: "Configuration des informations de base",
    deviceName: "Nom de l'appareil",
    nameTip:
      "Corrigé pour ajouter un numéro au nom du groupe auquel il appartient, par exemple, Bâtiment 1-1",
    function: "Fonction de prise en charge de l'appareil",
    net: "Configuration du réseau",
    netType: "Type de réseau",
    netTip1:
      "Static est un réseau statique, vous devez définir manuellement l'adresse IP et d'autres informations.",
    netTip2:
      "DHCP est un réseau dynamique, et des informations telles que l'IP sont automatiquement attribuées par le routeur.",
    mask: "Veuillez entrer le masque de sous-réseau",
    gateway: "Veuillez saisir la passerelle",
    ip: "Veuillez entrer l'adresse IP",
    ipTip:
      "L'adresse IP d'entrée doit éviter une adresse IP spéciale, telle que 127.0.0.1, etc.",
    dns1: "Veuillez entrer DNS1",
    dns2: "Veuillez entrer DNS2",
    sip1: "configuration des informations sip1",
    config: "Configuration des informations",
    mode: "modèle",
    mode1: "Mode direct",
    mode2: "Mode serveur",
    user: "veuillez entrer le nom d'utilisateur",
    userTitle: "nom d'utilisateur",
    userTip:
      "La valeur par défaut consiste à ajouter un numéro au nom du groupe, tel que 1-1-1",
    last: "Veuillez entrer le suffixe du compte",
    sipTip:
      "Veuillez saisir le nom d'utilisateur et le mot de passe enregistrés du serveur SIP",
    password: "S'il vous plait entrez votre mot de passe",
    passwordTitle: "mot de passe",
    serverIp: "Veuillez saisir l'IP du serveur",
    protocolType: "Veuillez sélectionner le type de protocole",
    protocolTypeTitle: "type d'accord",
    sip2: "configuration des informations sip2",
    more: "Plus",
    close: "fermeture",
    formatError: "Erreur de format, veuillez ressaisir",
    forbidTip: "Interdit d'entrer 127.0.0.1, veuillez ré-entrer",
    call: "Appelez et appelez",
    monitor: "moniteur",
    lift: "Contrôle d'ascenseur",
    rtsp: "flux vidéo rtsp",
    deviceTip:
      "La fonction de support de l'appareil ne peut pas être vide, veuillez choisir à nouveau",
    maskTip1:
      "Le masque de sous-réseau ne peut pas être vide, veuillez le saisir à nouveau",
    maskTip2:
      "Le format du masque de sous-réseau est incorrect, veuillez le saisir à nouveau",
    gatewayTip1:
      "La passerelle ne peut pas être vide, veuillez entrer à nouveau",
    gatewayTip2: "Erreur de format de passerelle, veuillez ré-entrer",
    ipTip1: "L'adresse IP ne peut pas être vide, veuillez la saisir à nouveau",
    ipTip2:
      "Erreur de format d'adresse IP, la limite supérieure est 255.254.254.253, le premier paragraphe n'est pas 0, veuillez ressaisir",
    dns1Tip1: "DNS1 ne peut pas être vide, veuillez ré-entrer",
    dns1Tip2: "Erreur de format DNS1, veuillez ressaisir",
    dns2Tip1: "Erreur de format DNS2, veuillez ressaisir",
    passwordTip1:
      "Le mot de passe ne peut pas être vide, veuillez le saisir à nouveau",
    serviceTip1:
      "serviceIp ne peut pas être vide, veuillez le saisir à nouveau",
    serviceTip2: "Erreur de format serviceIp, veuillez ressaisir",
    sip2Tip:
      "Vous avez actuellement configuré les informations sip2, merci de les compléter selon les règles",
    devnameTip1:
      "Le nom de l'appareil ne peut pas être vide, veuillez le saisir à nouveau",
    devnameTip2: "Erreur de format du nom de l'appareil, veuillez ré-entrer",
    nameTip1:
      "Le nom d'utilisateur ne peut pas être vide, veuillez choisir à nouveau",
    nameTip2:
      "Le nom d'utilisateur ne peut pas être vide, veuillez choisir à nouveau",
    maxTip1:
      "Le nombre d'appareils dans la zone actuelle a atteint la limite supérieure de 8, et aucun autre ne peut être ajouté",
    area: "zone",
    editArea: "Zone d'édition",
    addArea: "Ajouter une zone",
    batchArea: "Zone d'ajout par lots",
    deleteArea: "Supprimer la région",
    areaName: "Nom de zone",
    areaNo: "Numéro de zone",
    importAddr: "Importer le carnet d'adresses",
    next: "L'étape suivante",
    areaTip1: "Veuillez sélectionner la zone à modifier en premier",
    areaTip2: "Veuillez d'abord sélectionner la zone à supprimer",
    areaTip3:
      "Votre zone actuelle est vide, vous ne pouvez pas ajouter d'appareils par lots pour le moment, veuillez d'abord ajouter des informations sur la zone",
    noArea: "Pas encore de configuration de zone",
    error: "Exception de données",
    addDevice: "Ajouter un appareil",
    editDevice: "Modifier l'appareil",
    delDevice: "Supprimer l'appareil",
    batchDevice: "Ajouter des appareils par lots",
    prev: "Précédent",
    updateAddr: "Mettre à jour le carnet d'adresses de l'appareil",
    saveAddr: "Enregistrer le carnet d'adresses",
    exportAddr: "Exporter le carnet d'adresses",
    deleteTip: "S'il faut supprimer l'appareil",
    deleteTip2:
      "Actuellement sélectionné comme région, veuillez retourner à la configuration de la région pour supprimer",
    deleteTip3: "Veuillez d'abord sélectionner l'appareil à supprimer",
    deviceTip1: "Veuillez d'abord sélectionner l'appareil à modifier",
    deviceTip2:
      "Veuillez d'abord sélectionner la région, puis ajouter l'appareil",
    exportSuccess: "Exportation réussie",
    xmlTip: "Veuillez télécharger le fichier xml du carnet d'adresses",
    xmlTip1: "Veuillez sélectionner le fichier xml à télécharger",
    xmlTip2:
      "Le carnet d'adresses importé est incohérent avec le niveau de communauté actuel et l'importation a échoué",
    areaConfig: "Configuration de zone",
    deviceConfig: "Configuration de l'appareil",
    exportConfig: "Aperçu de l'exportation",
    projectConfig: "Configuration du projet",
    prevArea: "Appartient à la zone supérieure",
    areaNoTip:
      "Le numéro de début est supérieur au numéro de fin, veuillez le remplir à nouveau",
    smallAreaTip:
      "Actuellement le plus petit niveau de zone, aucune autre sous-zone ne peut être ajoutée",
    areaNoTip1:
      "Le numéro de début de la première partie est supérieur au numéro de fin de la première partie, veuillez le remplir à nouveau",
    areaNoTip2:
      "Le numéro de début de la queue est supérieur au numéro de fin de la queue, veuillez remplir à nouveau",
  },
  push: {
    list: "Pousser l'enregistrement",
    productType: "Numéro de produit",
    softwareName: "nom du logiciel",
    versionNo: "numéro de version",
    time: "Poussez le temps",
    invalidTime: "Date d'expiration ",
    upgrade: "améliorer",
    upgradeRecord: "Afficher l'enregistrement de mise à niveau",
    deviceType: "Type d'équipement",
    deviceName: "Nom de l'appareil",
    currentSoftName: "Nom du logiciel de l'appareil actuel ",
    currentSoftNo: "Numéro de version actuel de l'appareil",
    upgradeNo: "Numéro de version du logiciel de mise à jour",
    filterTip1: "Veuillez saisir le nom de l'appareil",
    filterTip2: "Veuillez sélectionner le nom du logiciel",
    filterTip3: "Veuillez sélectionner un numéro de version",
    checkTip: "Activer la tique",
    ota: "Mise à niveau OTA",
    taskName: "nom de la mission",
    taskNameTip: "Veuillez entrer un nom de tâche",
    binName: "Nom du micrologiciel",
    upgradeType: "Méthode de mise à niveau des tâches",
    done: "S'il faut exécuter immédiatement",
    upgradeTime: "temps de mise à niveau",
  },
  check: {
    submit: "Félicitations, la soumission est réussie !",
    noSubmit: "Oups, la soumission a échoué !",
    file: "Sélectionner un document",
    noFile: "Aucun fichier sélectionné",
    projectName: "nom du projet",
    projectNameTip: "Veuillez entrer un nom de projet",
    describe: "décrire",
    contentTip: "Veuillez entrer du contenu",
    areaType: "Hiérarchie des régions",
    example: "Par exemple : bâtiment-unité-chambre numéro",
    areaTip:
      "Le format du numéro de zone est incorrect, veuillez le saisir à nouveau",
    areaNameTip: "Veuillez entrer un nom de couche",
    nameTip: "Le nom ne peut pas être vide, veuillez le saisir à nouveau",
    nameError:
      "Le nom a été saisi de manière incorrecte, veuillez le saisir à nouveau",
    nameLength:
      "La longueur d'entrée du nom est de 4 à 50, veuillez entrer à nouveau",
    areaNullTip: "Le niveau de la zone ne peut pas être vide",
    formateError:
      "La longueur est de 1 à 6 chiffres, aucun symbole spécial ne peut être saisi",
    noAreaTip:
      "Le niveau de la zone ne peut pas être vide, veuillez sélectionner à nouveau",
    maxFileTip: "La taille du fichier dépasse la limite",
    xmlTip: "Veuillez télécharger un fichier au format XML",
  },
  book: {
    areaBy: "Région",
    list: "Liste des doublons d'informations sur l'appareil",
    repeatTip:
      "Les informations d'équipement suivantes sont dupliquées. Veuillez modifier les informations d'équipement dupliquées. Après avoir cliqué sur Confirmer,il évaluera la duplication des informations d 'entréed' équipement. ",
    coverTip:
      "Cette opération écrasera le lot en ajoutant des données du niveau actuellement sélectionné",
    batchTip: "La plage IP générée en ajoutant des appareils par lots",
  },
  updateNewSip: {
    otaDeleteTip:
      "Échec de la suppression, seules les tâches non démarrées peuvent être supprimées",
    deleteArea1: "S'il faut supprimer la région",
    deleteArea2:
      "En même temps, toutes les zones et tous les appareils situés en dessous de cette zone seront supprimés ensemble",
    codeRepeatTip:
      "L'ID de région du même niveau ne peut pas être répété, veuillez ressaisir l'ID de région actuel",
    nameRepeatTip:
      "Les noms de zone au même niveau ne peuvent pas être dupliqués, veuillez saisir à nouveau le nom de la région actuelle",
    deviceIp: "IP de l'appareil",
    callin: "Appelle",
    callout: "exhaler",
    systemMsg: "informations système",
    batchIpTip:
      "La plage IP générée en ajoutant des appareils par lots cette fois",
    ip: "Adresse IP",
    mask: "Masque de sous-réseau",
    gateway: "Passerelle",
    noData: "Non",
    noAddressTip:
      "Il n'existe actuellement aucune donnée de carnet d'adresses pouvant être synchronisée",
    operator: "Opérateur",
    goTip: "Cliquez pour passer à l'étape correspondante",
    deviceNameTip:
      "La longueur d'entrée est de 1 à 16 chiffres, aucun symbole spécial ne peut être saisi",
    filter1: "Entrez un nom de zone à filtrer",
    filter2: "Entrez le nom de la zone ou le nom de l'appareil à filtrer",
    secret: "Mot de passe de cryptage",
    secretTip:
      "Veuillez entrer un mot de passe de moins de 32 caractères, le format n'est pas limité",
    noSecretTip: "Le mot de passe de chiffrement non défini peut être ignoré",
    setSecret: "Définir le mot de passe de cryptage du carnet d'adresses",
    ignore: "négligence",
    emptyBookTip:
      "Le carnet d'adresses est vide et ne peut pas être exporté temporairement",
    errorSecret:
      "Erreur de mot de passe de cryptage du carnet d'adresses, veuillez le saisir à nouveau",
    other: "autre",
    doorAuth: "Contrôle d'accès",
    funTitle:
      "Veuillez vérifier les fonctions prises en charge par l'appareil que vous avez ajouté",
    callInTip: "Appel d'assistance de l'appareil",
    callOutTip: "Le support de l'appareil est appelé",
    monitorTip: "L'appareil prend en charge la surveillance",
    doorTip: "L'appareil prend en charge la fonction de déverrouillage",
    liftTip: "Ascenseur de contrôle de support de périphérique",
    maskTip:
      "Veuillez saisir le masque de sous-réseau, référence du format : 255.255.255.255",
    gatewayTip: "Veuillez saisir la passerelle, référence du format : 1.1.1.1",
    ip1: "Veuillez entrer l'adresse IP, référence du format : 1.1.1.1",
    ipTip:
      "L'adresse IP d'entrée doit éviter une adresse IP spéciale, telle que 127.0.0.1, etc.",
    dns1: "Veuillez entrer DNS1, référence de format : 1.1.1.1",
    dns2: "Veuillez entrer DNS2, référence de format : 1.1.1.1",
    serverIp:
      "Veuillez entrer serverIp, référence de format : 1.1.1.1 ou nom de domaine",
    successxml: "Fichier analysé avec succès",
    groupCall: "appel de groupe",
    groupCallTip:
      "Une fois allumé, vous pouvez appeler tous les appareils du groupe en cliquant sur l'icône d'appel de groupe",
    record: "enregistrement de version",
    export: "exporter",
    sync: "Synchroniser",
    communityTip:
      "Actuellement, il y a des données de périphérique de zone, le changement de niveau de zone est interdit",
    areaNameTitle: "Description de la hiérarchie",
    noDataTip: "Aucune donnée",
    areaCodeDescriptionTip:
      "La description de la zone n'est pas vide, veuillez la remplir complètement",
    moduleName: "Outil de configuration du carnet d'adresses",
    userSipAccount:
      "Fixe comme numéro de zone du Groupe supérieur auquel appartient + numéro de série de l'appareil",
    devMax:
      "Le nœud de l'appareil a dépassé la limite de 10000 entrées, l'ajout a échoué",
    areaMax:
      "Le nœud de zone a dépassé la limite de 10000 entrées, l'ajout a échoué",
    ipAndMaskTip1:
      "L'adresse IP est associée au masque de sous-réseau et doit respecter la logique métier en ayant des résultats avec tous les 1 ou tous les 0 après l'opération ET bit à bit.",
    ipAndMaskTip2:
      "En cas d'erreur de règle de validation métier, veuillez modifier l'adresse IP correspondante.",
    ipAndMaskTip3:
      "Les règles de validation métier du masque de sous-réseau et de l'adresse IP sont incorrectes. Veuillez modifier l'adresse IP.",
    ipAndMaskTip4:
      "Lors de l'ajout en masse d'appareils, les adresses IP qui ne respectent pas la validation de la logique métier seront automatiquement ignorées.",
    correctMaskTip:
      "Veuillez d'abord remplir le masque de sous-réseau correctement.",
    correctIpTip: "Veuillez entrer l'adresse IP correcte.",
  },
  newDeviceType: {
    indoorMachine: "Unité intérieure",
    doorPhone: "Interphone",
    smallDoor: "Interphone petit",
    manage: "Dispositif de gestion",
    wall: "Dispositif mural",
    monitor: "Caméra IP",
    unitGuard: "Dispositif de gestion de l'unité",
    networkCard: "Lecteur de cartes réseau",
    unitCard: "Lecteur de cartes d'unité",
    lift: "Module de liaison avec l'ascenseur",
    deviceTypeTip: "Veuillez sélectionner le type de dispositif"
    }
};
